import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import {chain, ChangeCustomerContext} from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/ApplyChanges";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getLocationPathAndQuery } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CustomHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomHandler<HasOnSuccess & HasOnError<string>>;

export const ChangeCustomerContextUpdated: HandlerType = async ({ dispatch, getState, parameter: { onError } }) => {
    const { fulfillmentMethod, selectedBillTo, selectedShipTo, pickUpWarehouse } =
        getState().components.addressDrawer;
        const dataWarehouse = getState().WhiteCap.changeCustomerWarehouseData;

    const awaitableChangeCustomerContext = makeHandlerChainAwaitable(changeCustomerContext);

    await awaitableChangeCustomerContext({
        billToId: selectedBillTo?.id,
        shipToId: selectedShipTo?.id,
        fulfillmentMethod,
        isDefault: true,
        pickUpWarehouse:fulfillmentMethod === FulfillmentMethod.PickUp ? pickUpWarehouse : dataWarehouse?.Warehouse ? dataWarehouse.Warehouse : null,
        returnUrl: getLocationPathAndQuery(getState()),
        onError: (errorMessage: string) => {
            onError?.(errorMessage);
            dispatch({
                type: "Components/AddressDrawer/CompleteApplyChanges",
            });
        },
    })(dispatch, getState);
};
replaceInChain(chain, ChangeCustomerContext, ChangeCustomerContextUpdated);
